// extracted by mini-css-extract-plugin
export var button = "_cg-1";
export var iconWrapper = "_cg-0";